import { useEffect, useRef, useState } from "react";
import { MultipleAlertMessages } from "../../models/messages/Messages";
import Model from "../../models/Model";
import { Classify } from "../../services/classification/Classify";
import { ModelUrlState } from "../../state/ModelUrlState";
import { ModelStore } from "../../stores/impl/ModelStore";
import "../../styles/classification/multipleModelAlert.css";
import { useAsync } from "../hooks/useAsync";
import Icon from "../Icon";
import { Spinner } from "../Spinner";

export { MultipleModelAlert };

type Props = {
  docUuid: string;
  /** Override for testing */
  classify?: Classify;
  /** Use default ModelStore if not provided. */
  modelStore?: typeof ModelStore;
};

const MultipleModelAlert = (props: Props) => {
  const classifyRef = useRef(props.classify ?? new Classify());
  const modelStoreRef = useRef(props.modelStore ?? ModelStore);

  const [open, setOpen] = useState(false);

  const [error, setError] = useState<unknown | null>(null);

  const [result, trigger, loading, setResult] = useAsync(async () => {
    try {
      const modelUuids = await classifyRef.current.firstPage(props);
      const models = await Promise.all(
        (modelUuids ?? []).map((x) => modelStoreRef.current.lookupByUuid(x)),
      );
      return models.filter((m): m is Model => m != null);
    } catch (e) {
      console.error("Error classifying Document", e);
      setError(e);
    }
  }, null);

  useEffect(() => {
    setOpen(false);
    setError(null);
    setResult(null);
  }, [props.docUuid]);

  return (
    <div className={"multipleModelBox"}>
      <span>{MultipleAlertMessages.classifiedMultiple()}</span>

      {!loading && (
        <Icon
          onClick={() => {
            // inherently means not open
            const nextOpen = !open;
            if (nextOpen) {
              trigger();
            } else {
              setResult(null);
              setError(null);
            }
            setOpen(nextOpen);
          }}
          altText={"Open Classsified Models"}
          icon={open ? "chevron-up" : "chevron-down"}
        />
      )}
      {loading && <Spinner />}

      <div className={`results ${open && !loading ? "open" : "closed"}`}>
        {open && (
          <>
            <ul>
              {result &&
                result.map((x) => (
                  <li key={x.uuid!} data-model-uuid={x.uuid}>
                    {/* {x.getName()} */}
                    <a
                      target={"_blank"}
                      href={`template-management.html${ModelUrlState.calculateUrlFragments(x.storeId)}`}
                      rel="noreferrer"
                    >
                      {x.getName()}
                    </a>
                  </li>
                ))}
            </ul>
            {result && result.length === 0 && (
              <p>{MultipleAlertMessages.noTemplatesClassified()}</p>
            )}
            {error != null && (
              <p>{MultipleAlertMessages.errorCheckingMultiple()}</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};
